import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';


import './styles.scss';

export default class SinglePhotoPhotoSectionCheckoutLicense extends React.Component {
    static propTypes = {
        photo: PropTypes.shape({
            license: PropTypes.string.isRequired,
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired
        }).isRequired
    };

    render() {
        const { license, width, height } = this.props.photo;

        return (
            <div className="single-photo-photo-section-checkout-license">
                <p className="photo-license">
                    {I18n.t('SINGLE_PHOTO.checkout.defaultLicense')}, {license.toLowerCase() === 'editorial' ? I18n.t('SINGLE_PHOTO.checkout.licenses.editorial') : I18n.t('SINGLE_PHOTO.checkout.licenses.commercial')}
                </p>
                <p className="photo-metadata">
                    {I18n.t('SINGLE_PHOTO.checkout.size')}: {width} x {height} px <br />
                    {I18n.t('SINGLE_PHOTO.checkout.fileFormat')}: JPG
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/Photo/components/CheckoutLicense/index.js